import { apiRequest } from '@/core';
import { type ExternalEntity } from '@/types';

export const fetchSportsRequest = async () =>
  apiRequest<ExternalEntity[]>({
    endpoint: 'api/sports',
  });
